import { Card, Empty, Popover } from 'antd';
import Title from 'antd/es/typography/Title';

import { EMPTY_MESSAGES, OWNER_AVATAR_SIZES } from '@/shared/lib/constants';
import type { OwnerEditHook } from '@/shared/types/editHooks';
import type { UpdateOwnerItem } from '@/shared/types/owner';
import { Icon } from '@/shared/ui/Icon';
import { IconButton } from '@/shared/ui/IconButton';
import { OwnerAvatars } from '@/shared/ui/OwnerAvatars';
import { OwnerEditPopover } from '@/shared/ui/OwnerEditPopover';

import styles from './OwnerCard.module.css';

export type OwnerCardOwner = Pick<UpdateOwnerItem, 'id' | 'type' | 'name' | 'displayName'>;
export type OwnerCardProps = {
  title?: string;
  owners: OwnerCardOwner[];
  ownerEdit: OwnerEditHook;
  disabled?: boolean;
};

export const OwnerCard = ({ title = '소유자', owners, ownerEdit, disabled }: OwnerCardProps) => {
  const renderOwnerDisplay = () => {
    if (owners.length === 0) {
      return <Empty description={EMPTY_MESSAGES.NO_OWNERS} image={Empty.PRESENTED_IMAGE_SIMPLE} />;
    }

    return <OwnerAvatars owners={owners} size={OWNER_AVATAR_SIZES.DETAIL} showName={true} />;
  };

  return (
    <Card className={styles.card}>
      <div className={styles.cardHeader}>
        <Title level={5} className={styles.cardTitle}>
          {title}
        </Title>
        <Popover
          content={<OwnerEditPopover ownerEdit={ownerEdit} />}
          title="소유자 편집"
          trigger="click"
          open={ownerEdit.isOpen}
          onOpenChange={(visible) => (visible ? ownerEdit.handleOpen() : ownerEdit.handleClose())}
          placement="bottomLeft">
          <IconButton size="small" disabled={disabled} tooltip="소유자 편집">
            <Icon name="edit" size={16} />
          </IconButton>
        </Popover>
      </div>
      {renderOwnerDisplay()}
    </Card>
  );
};
